<template>
  <div class="wrapper history-page">
    <!-- Header -->
    <Header />
    <!-- HeaderMenu -->
    <HeaderMenu />

    <div class="contents">
      <div class="layout">
        <div class="pc-only main">
          <h1>{{ $t("HISTORY") }}</h1>
        </div>
        <div class="left">
          <div class="pc-only">
            <Sidebar />
          </div>
        </div>
        <div class="right">
          <div class="sp-only">
            <h1>{{ $t("HISTORY") }}</h1>
          </div>
          <div class="tab-area">
            <div
              class="tab link-over"
              v-on:click="isSelect('2')"
              v-bind:class="{ active: isActive === '2' }"
            >
              {{ $t("Deposit and withdrawal") }}
            </div>
            <div
              class="tab link-over"
              v-on:click="isSelect('3')"
              v-bind:class="{ active: isActive === '3' }"
            >
              {{ $t("Plan purchase") }}
            </div>
            <div
              class="tab link-over"
              v-on:click="isSelect('1')"
              v-bind:class="{ active: isActive === '1' }"
            >
              {{ $t("Staking") }}
            </div>
            <div
              class="tab link-over"
              v-on:click="isSelect('4')"
              v-bind:class="{ active: isActive === '4' }"
            >
              {{ $t("PP") }}
            </div>
          </div>
          <div
            class="content-area"
            v-show="isActive === '1'"
            v-bind:class="{ active: isActive === '1' }"
          >
            <div class="table">
              <h2>{{ $t("Staking History") }}</h2>
              <table>
                <tr>
                  <th>{{ $t("Date") }}</th>
                  <th>{{ $t("Currency") }}</th>
                  <th>{{ $t("Amount") }}</th>
                  <!-- <th>{{ $t("Type") }}</th> -->
                </tr>
                <tr>
                  <td>2020.04.10<br />12:23:32</td>
                  <td>USDT</td>
                  <td>0.01USDT</td>
                  <!-- <td>{{ $t("REFERRAL") }}</td> -->
                </tr>
                <tr>
                  <td>2020.04.10<br />12:23:32</td>
                  <td>USDT</td>
                  <td>0.01USDT</td>
                  <!-- <td>{{ $t("REWARD") }}</td> -->
                </tr>
                <tr>
                  <td>2020.04.10<br />12:23:32</td>
                  <td>USDT</td>
                  <td>0.01USDT</td>
                  <!-- <td>{{ $t("UNILEVEL") }}</td> -->
                </tr>
                <tr>
                  <td>2020.04.10<br />12:23:32</td>
                  <td>USDT</td>
                  <td>0.01USDT</td>
                  <!-- <td>{{ $t("REWARD") }}</td> -->
                </tr>
              </table>
            </div>
            <div class="pager">
              <span class="prev">
                <a href="#" class="link-over">
                  <img src="../assets/img/left-arrow-img.png" alt="" />
                </a>
              </span>
              <span class="page-item active"
                ><a href="#" class="link-over">1</a></span
              >
              <span class="page-item"><a href="#" class="link-over">2</a></span>
              <span class="page-item"><a href="#" class="link-over">3</a></span>
              <span class="next">
                <a href="#" class="link-over">
                  <img src="../assets/img/right-arrow-img.png" alt="" />
                </a>
              </span>
            </div>
          </div>
          <div
            class="content-area"
            v-show="isActive === '2'"
            v-bind:class="{ active: isActive === '2' }"
          >
            <div class="table">
              <h2>{{ $t("Deposit and withdrawal history") }}</h2>
              <table>
                <tr>
                  <th>{{ $t("Date") }}</th>
                  <th>{{ $t("Currency") }}</th>
                  <th>{{ $t("Amount") }}</th>
                  <th>{{ $t("Type") }}</th>
                </tr>
                <tr>
                  <td>2020.04.10<br />12:23:32</td>
                  <td>USDT</td>
                  <td>0.01USDT</td>
                  <td>{{ $t("DEPOSIT") }}</td>
                </tr>
                <tr>
                  <td>2020.04.10<br />12:23:32</td>
                  <td>BTC</td>
                  <td>0.01USDT</td>
                  <td>{{ $t("WITHDRAW") }}</td>
                </tr>
                <tr>
                  <td>2020.04.10<br />12:23:32</td>
                  <td>USDT</td>
                  <td>0.01USDT</td>
                  <td>{{ $t("DEPOSIT") }}</td>
                </tr>
                <tr>
                  <td>2020.04.10<br />12:23:32</td>
                  <td>USDT</td>
                  <td>0.01USDT</td>
                  <td>{{ $t("WITHDRAW") }}</td>
                </tr>
              </table>
            </div>
            <div class="pager">
              <span class="prev">
                <a href="#" class="link-over">
                  <img src="../assets/img/left-arrow-img.png" alt="" />
                </a>
              </span>
              <span class="page-item active"
                ><a href="#" class="link-over">1</a></span
              >
              <span class="page-item"><a href="#" class="link-over">2</a></span>
              <span class="page-item"><a href="#" class="link-over">3</a></span>
              <span class="next">
                <a href="#" class="link-over">
                  <img src="../assets/img/right-arrow-img.png" alt="" />
                </a>
              </span>
            </div>
          </div>
          <div
            class="content-area"
            v-show="isActive === '3'"
            v-bind:class="{ active: isActive === '3' }"
          >
            <div class="table">
              <h2>{{ $t("Plan Purchase history") }}</h2>
              <table>
                <tr>
                  <th>{{ $t("Date") }}</th>
                  <th>{{ $t("Point") }}</th>
                  <th>{{ $t("Plan") }}</th>
                  <th>{{ $t("Number of points") }}</th>
                </tr>
                <tr>
                  <td>2020.04.10<br />12:23:32</td>
                  <td>USD</td>
                  <td>{{ $t("Bronze") }}</td>
                  <td>500USD</td>
                </tr>
                <tr>
                  <td>2020.04.10<br />12:23:32</td>
                  <td>RP</td>
                  <td>{{ $t("Bronze") }}</td>
                  <td>500USD</td>
                </tr>
                <tr>
                  <td>2020.04.10<br />12:23:32</td>
                  <td>USD</td>
                  <td>{{ $t("Silver") }}</td>
                  <td>1000USD</td>
                </tr>
                <tr>
                  <td>2020.04.10<br />12:23:32</td>
                  <td>RP</td>
                  <td>{{ $t("Silver") }}</td>
                  <td>1000USD</td>
                </tr>
              </table>
            </div>
            <div class="pager">
              <span class="prev">
                <a href="#" class="link-over">
                  <img src="../assets/img/left-arrow-img.png" alt="" />
                </a>
              </span>
              <span class="page-item active"
                ><a href="#" class="link-over">1</a></span
              >
              <span class="page-item"><a href="#" class="link-over">2</a></span>
              <span class="page-item"><a href="#" class="link-over">3</a></span>
              <span class="next">
                <a href="#" class="link-over">
                  <img src="../assets/img/right-arrow-img.png" alt="" />
                </a>
              </span>
            </div>
          </div>
          <div
            class="content-area"
            v-show="isActive === '4'"
            v-bind:class="{ active: isActive === '4' }"
          >
            <div class="table">
              <h2>{{ $t("pp history") }}</h2>
              <table>
                <tr>
                  <th>{{ $t("Date") }}</th>
                  <th>{{ $t("Type") }}</th>
                  <th>{{ $t("Amount") }}</th>
                  <th>{{ $t("Balance") }}</th>
                </tr>
                <tr>
                  <td>2020.04.10<br />12:23:32</td>
                  <td>バイナリーオーバー</td>
                  <td>10</td>
                  <td>100</td>
                </tr>
                <tr>
                  <td>2020.04.10<br />12:23:32</td>
                  <td>バイナリー20%</td>
                  <td>10</td>
                  <td>90</td>
                </tr>
                <tr>
                  <td>2020.04.10<br />12:23:32</td>
                  <td>購入</td>
                  <td>-10</td>
                  <td>80</td>
                </tr>
                <tr>
                  <td>2020.04.10<br />12:23:32</td>
                  <td>バイナリー20%</td>
                  <td>10</td>
                  <td>90</td>
                </tr>
              </table>
            </div>
            <div class="pager">
              <span class="prev">
                <a href="#" class="link-over">
                  <img src="../assets/img/left-arrow-img.png" alt="" />
                </a>
              </span>
              <span class="page-item active"
                ><a href="#" class="link-over">1</a></span
              >
              <span class="page-item"><a href="#" class="link-over">2</a></span>
              <span class="page-item"><a href="#" class="link-over">3</a></span>
              <span class="next">
                <a href="#" class="link-over">
                  <img src="../assets/img/right-arrow-img.png" alt="" />
                </a>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /.contents -->

    <Footer title="History" />
  </div>
</template>
<style scoped></style>
<script>
import Header from "@/components/Header.vue";
import HeaderMenu from "@/components/HeaderMenu.vue";
import Sidebar from "@/components/Sidebar.vue";
import Footer from "@/components/Footer.vue";
export default {
  name: "History",
  components: {
    Header,
    HeaderMenu,
    Sidebar,
    Footer,
  },
  data: () => {
    return {
      title: "History",
      isActive: "2",
    };
  },
  methods: {
    isSelect: function (num) {
      this.isActive = num;
    },
  },
  computed: {},
  mounted: function () {},
};
</script>
